import styles from './Badge.module.css';
interface BadgeProps {
  value: string;
  backgroundColor?: string;
  textColor?: string;
  ballColor?: string;
}
const Badge = ({
  value,
  backgroundColor,
  textColor,
  ballColor,
}: BadgeProps) => {
  return (
    <div
      className={styles.square}
      style={{
        color: textColor || ballColor,
        backgroundColor,
        textAlign: 'center',
      }}
    >
      <div
        className={styles.roundedBall}
        style={{
          backgroundColor: ballColor,
          fontWeight: 700,
        }}
      ></div>
      {value}
    </div>
  );
};

export default Badge;